// The three room-switcher icons, shared with `ThreadRoster.tsx`: the icon encodes HOW MANY
// PEOPLE are in the room, not a shared "chat" glyph — a single figure (private), two
// figures (the co-principals' room), a group of three (the full conversation). See
// `RoomSwitcher.tsx`'s header comment for the full reasoning; this file only holds the
// markup both components draw the same icon from.

export function PrivateIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" width="1.1rem" height="1.1rem" aria-hidden="true">
      <circle cx="12" cy="8" r="4" fill="currentColor" />
      <path d="M4 20c0-4.4 3.6-7 8-7s8 2.6 8 7" fill="currentColor" />
    </svg>
  );
}

export function TwoIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" width="1.1rem" height="1.1rem" aria-hidden="true">
      <circle cx="9" cy="8" r="3.4" fill="currentColor" />
      <circle cx="17" cy="9" r="2.8" fill="currentColor" opacity="0.75" />
      <path d="M2 20c0-3.9 3.1-6.2 7-6.2s7 2.3 7 6.2" fill="currentColor" />
      <path d="M15.5 14.3c3 .5 5 2.5 5 5.7h-3" fill="currentColor" opacity="0.75" />
    </svg>
  );
}

export function GroupIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" width="1.1rem" height="1.1rem" aria-hidden="true">
      <circle cx="12" cy="7" r="3.2" fill="currentColor" />
      <circle cx="4.5" cy="9" r="2.4" fill="currentColor" opacity="0.75" />
      <circle cx="19.5" cy="9" r="2.4" fill="currentColor" opacity="0.75" />
      <path d="M5.5 20c0-3.6 2.9-5.8 6.5-5.8s6.5 2.2 6.5 5.8" fill="currentColor" />
      <path d="M2 19.6c.2-2.6 1.9-4.2 4.2-4.6" fill="currentColor" opacity="0.75" />
      <path d="M22 19.6c-.2-2.6-1.9-4.2-4.2-4.6" fill="currentColor" opacity="0.75" />
    </svg>
  );
}
